export var EApplicationEventType;
(function (EApplicationEventType) {
    EApplicationEventType["CREATE_USER_ACCOUNT"] = "CREATE_USER_ACCOUNT";
    EApplicationEventType["CREATE_INVESTMENT"] = "CREATE_INVESTMENT";
    EApplicationEventType["CREATE_ASSET"] = "CREATE_ASSET";
    EApplicationEventType["EDIT_INVESTMENT"] = "EDIT_INVESTMENT";
    EApplicationEventType["EDIT_ASSET"] = "EDIT_ASSET";
    EApplicationEventType["DELETE_INVESTMENT"] = "DELETE_INVESTMENT";
    EApplicationEventType["DELETE_ASSET"] = "DELETE_ASSET";
    EApplicationEventType["DELETE_ATTACHMENT"] = "DELETE_ATTACHMENT";
    EApplicationEventType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    EApplicationEventType["UPDATE_ATTACHMENT"] = "UPDATE_ATTACHMENT";
    EApplicationEventType["FILE_TRANSACTION_COMPLETE"] = "FILE_TRANSACTION_COMPLETE";
    EApplicationEventType["PROVIDER_IMPORT"] = "PROVIDER_IMPORT";
    EApplicationEventType["MANUAL_PROVIDER_IMPORT"] = "MANUAL_PROVIDER_IMPORT";
    EApplicationEventType["AUTOMATIC_PROVIDER_IMPORT"] = "AUTOMATIC_PROVIDER_IMPORT";
    EApplicationEventType["RESOLVE_INVITE"] = "RESOLVE_INVITE";
    EApplicationEventType["INVITE_ALREADY_RESOLVED"] = "INVITE_ALREADY_RESOLVED";
    EApplicationEventType["EDIT_USER_PROFILE"] = "EDIT_USER_PROFILE";
    EApplicationEventType["AUTOMATIC_ASSET_UPDATE"] = "AUTOMATIC_ASSET_UPDATE";
})(EApplicationEventType || (EApplicationEventType = {}));
